(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pw-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__PIELURD_LANGUAGE_SWITCHER_V2__) return;
    window.__PIELURD_LANGUAGE_SWITCHER_V2__ = true;

    const selector = '[data-pw-language-switcher]';

    const closeSwitcher = switcher => {
      if (!switcher?.open) return;
      switcher.open = false;
    };

    document.addEventListener('click', event => {
      document.querySelectorAll(selector + '[open]').forEach(switcher => {
        if (!switcher.contains(event.target)) closeSwitcher(switcher);
      });
    });

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const switcher = document.querySelector(selector + '[open]');
      if (!switcher) return;
      closeSwitcher(switcher);
      switcher.querySelector('summary')?.focus();
    });

    document.addEventListener('toggle', event => {
      const switcher = event.target;
      if (!switcher.matches?.(selector) || !switcher.open) return;
      document.querySelectorAll(selector + '[open]').forEach(other => {
        if (other !== switcher) closeSwitcher(other);
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
